import { useTheme } from '@mui/material/styles'
import { isArray } from 'lodash'
import React from 'react'

interface Props {
  children?: React.ReactNode[] | React.ReactNode
  wrap?: boolean
  my?: number
  mx?: number
}

const ButtonContainer: React.FC<Props> = ({
  wrap,
  children,
  my = 8,
  mx = 0,
}) => {
  const theme = useTheme()
  return (
    <div
      style={{
        margin: theme.spacing(my, mx),
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        ...(wrap && {
          flexWrap: 'wrap',
        }),
      }}>
      {isArray(children) ? (
        children.map((child, i) => <div key={i}>{child}</div>)
      ) : (
        <div>{children}</div>
      )}
    </div>
  )
}

export default ButtonContainer
